const ogLocales = {
  en: 'en_US',
  cs: 'cs_CZ',
  pl: 'pl_PL',
  nl: 'nl_NL',
  de: 'de_DE',
  hu: 'hu_HU',
  pt: 'pt_PT',
  it: 'it_IT',
  fr: 'fr_FR',
  es: 'es_ES'
}

export const getOgLocale = (lang: LangCode) => ogLocales[lang]
